import React, { useState, useEffect, useMemo } from 'react';
import Table from '../partials/Table';
import '../../styles/privacyRequests.css'
import styled from 'styled-components';
import axios from 'axios';
import { MdOutlineUnsubscribe , MdOutlineDeleteForever } from 'react-icons/md'
import { HiMagnifyingGlass } from 'react-icons/hi2'
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { connect } from 'react-redux';
import EditNotesForm from '../forms/EditNotesForm';


function PrivacyRequestsTable (props, { limit, unsubUser }){

    const [data, setData] = useState();
    const [loadingData, setLoadingData] = useState(true);
    const [open, setOpen] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [formData, setFormData] = useState({});
    const [note, setNote] = useState("");
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [id, setId] = useState("");
    const [lastName, setLastName] = useState("");
    const [updateAction, setUpdateAction] = useState("");
    const [updatedBy, setUpdatedBy] = useState("")
    const [updatedId, setUpdatedId] = useState("");
    const handleClose = () => setOpen(false);
    const handleUpdateClose = () => setOpenUpdate(false);
    const handleDeleteClose = () => setOpenDelete(false);

    useEffect(() => {
        props.onChange({
            email, firstName,lastName,id
          });

        if (loadingData) {
        // if the result is not ready so you make the axios call
            getPrivacyRequests();
        }    
    }, [email, firstName, lastName, id]);

    const handleOpen = (note, updatedBy, id) => {
        setUpdatedId(id)
        setNote(note);
        setUpdatedBy(updatedBy);
        setOpen(true)
    };

    const handleOpenDelete = (email, id) => {
        setId(id)
        setEmail(email)
        setOpenDelete(true)
    }

    const getPrivacyRequests = () => {
        
        axios
        .get(`${process.env.REACT_APP_API_URL || ''}/privacy/getRequests`, {limit: limit})
        .then(response => {
            setData(response.data);
            let tableData = response.data;
            setLoadingData(false);
        })
    
    };

    const handleUnsub = (email, id) => {
        setEmail(email);
        props.unsubUser(email);
        setUpdateAction("Unsubscribed")
        var today = new Date(),
            date =   (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();

        setOpenUpdate(true)
        setTimeout(() => {
            handleNotesUpdate(`${email} unsubscribed on ${date}`, id)
        }, 2000)        
    }

    const handleDelete = (email) => {
        props.deleteUser(email);
        setUpdateAction("Deleted")
        var today = new Date(),
        date =   (today.getMonth() + 1) + '/' + today.getDate() + '/' + today.getFullYear();

        setOpenDelete(false)
        setTimeout(() => {
            handleNotesUpdate(`${email} deleted on ${date}`, id)
        }, 2000) 
    }

    const handleNotesUpdate = (note, id) => {

        let data = {
            id: id,
            param: "action_taken",
            value: note,
            user: props.user.username ? props.user.username : ""
        }

        axios.post(`${process.env.REACT_APP_API_URL || ''}/privacy/requests/update`, data)
        .then(response => {
            setLoadingData(true);
            getPrivacyRequests();
            // props.dispatch({ type: 'PRIVACY_DATA', tableData });
        })
        handleClose();
        handleUpdateClose();
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Date Requested',
                accessor: 'created_at',
            },
            {
                Header: 'Email',
                accessor: 'email',
            },
            {
                Header: 'Name',
                accessor: d => d.first_name + " " + d.last_name,
            },
            {
                Header: 'Phone',
                accessor: 'phone',
            },
            {
                Header: 'State',
                accessor: 'state',
            },
            {
                Header: 'Request Type',
                accessor: 'request_type',
            },
            {
                Header: 'Options',
                accessor: '',
                Cell: ({row}) => {
                    const email = row.original.email
                    return <span className="d-flex justify-content-around"> 
                    <Tooltip title="Unsubscribe">
                        <IconButton onClick={(e) => handleUnsub(row.original.email, row.original.id)}><MdOutlineUnsubscribe /></IconButton>
                    </Tooltip> &nbsp; 
                    <Tooltip title="Find">
                        <IconButton><HiMagnifyingGlass /></IconButton>
                    </Tooltip> &nbsp;  
                    <Tooltip title="Delete">
                        <IconButton onClick={(e) => handleOpenDelete(row.original.email, row.original.id)}><MdOutlineDeleteForever /></IconButton>
                    </Tooltip>   
                    </span>
                }
            },
            {
                Header: 'Notes',
                accessor: 'action_taken',
                Cell: ({row}) => {
                    return <div> 
                            {row.original.action_taken ? row.original.action_taken : ""} - <small>{row.original.resolved_by}</small>
                            <Button onClick={(e) => handleOpen(row.original.action_taken, row.original.resolved_by, row.original.id)} >Edit</Button>

                        </div>
                }
            }
        ],[]
    );

    return (
        <>
            {loadingData ? (
                <p>Loading Please wait...</p>
            ) : (
                <Styles>
                    <Table className="repostTable" columns={columns} data={data} />
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <EditNotesForm oldNote={note} oldUpdatedBy={updatedBy} handleNotesUpdate={handleNotesUpdate} id={updatedId} user={props.user.username ? props.user.username : "" } />
                        </Box>
                    </Modal>
                    <Modal
                        open={openUpdate}
                        onClose={handleUpdateClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                {props.errors ? 
                                    <div>Error. Please Try Again.</div>
                                    :
                                    <div>{email} successfully {updateAction}</div>
                                }
                            </Typography>
                        </Box>
                    </Modal>
                    <Modal
                        open={openDelete}
                        onClose={handleDeleteClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style}>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                Are you sure you want to delete this record, {email}? This action is irreversible.
                                <Button style={{width: '100%', marginTop: '10px'}} onClick={() => handleDelete(email)} className="formButton" type="submit">
                                    Delete Permanently
                                </Button>
                            </Typography>
                        </Box>
                    </Modal>
                </Styles>
            )}
        </>
    );
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const Styles = styled.div`
  padding: 1rem 0;

  table {
    border-collapse: separate;
    border: 1px solid #66BFBF;
    width: 100%;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #66BFBF;
      border-right: 1px solid #66BFBF;
      :last-child {
        border-right: 0;
      }
    }
   
  }
`;


const mapStateToProps = function (state) {
    return {
      user: state.userReducer.user,
      isLoggedIn: state.userReducer.isLoggedIn,
    };
  };
  
export default connect(mapStateToProps)(PrivacyRequestsTable);